// src/components/SWUpdateNotifier.js
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { notify } from "react-notify-toast";

export default function SWUpdateNotifier() {
  const { t } = useTranslation();

  useEffect(() => {
    const handleUpdate = () => {
      notify.show(
        `${t("update.new_version_available")} 🎄`,
        "custom",
        5000,
        { background: "#FFD700", text: "#002b43", fontWeight: "bold" }
      );

      // Reload nach kurzer Verzögerung
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    };

    window.addEventListener("swUpdateAvailable", handleUpdate);
    return () => window.removeEventListener("swUpdateAvailable", handleUpdate);
  }, [t]);

  return null;
}
